<div class="stick-top">
  <mat-toolbar>
    <mat-icon>terrain</mat-icon> Environments
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/domain/environments/0">
        <mat-icon>add</mat-icon>
        Create a new Environment
      </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
          </div>
      </th>
        <th>
          <div class="vbox">
            Name
            <input [(ngModel)]="filter.name">
          </div>
        </th>
        <th>
          <div class="vbox">
            Code
            <input [(ngModel)]="filter.code">
          </div>
        </th>
        <th>
          <div class="vbox">
            Description
            <input [(ngModel)]="filter.description">
          </div>
        </th>
        <th>
          <div class="vbox">
            Active
            <input [(ngModel)]="filter.active">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
        <td><a routerLink="/domain/environments/{{element.id}}">{{element.name}}</a></td>
        <td>{{element.code}}</td>
        <td>{{element.description}}</td>
        <td>{{element.active}}</td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
